import * as actionTypes from '../actions/actionTypes';

const initialState = { inventorys: [] }

const inventorysReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_INVENTORYS: {
            return {
                ...state,
                inventorys: action.data
            }
        }
        case actionTypes.CREATE_INVENTORY: {
            console.log(action.data);

            return {
                ...state,
                inventorys: [...state.inventorys, action.data]
            }
        }
        case actionTypes.UPDATE_INVENTORY: {
            console.log(action.data)
            return {
                ...state,
                inventorys: state.inventorys.map((item) => {
                    if (item.id === action.data.id) {
                        return { ...action.data }
                    }
                    return item
                })
            }
        }
        case actionTypes.DELETE_INVENTORY: {
            console.log(action.id, state.inventorys.filter(inventory => inventory.id !== action.id))
            return {
                ...state,
                inventorys: state.inventorys.filter(inventory => inventory.id !== action.id)
            }
        }
        case actionTypes.CLEAR_SALE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

const tempState = {};
const tempInventory = (state = tempState, action) => {
    switch (action.type) {
        case actionTypes.TEMPORARY_INVENTORY: {
            console.log('-----------', action);

            return {
                ...tempState,
                ...action.data
            }
        }
        case actionTypes.CLEAR_TEMPORARY_INVENTORY: {
            return {}
        }
        default: {
            return tempState;
        }
    }
}

export { tempInventory, inventorysReducer as default }